import React from "react";

const Instruction = ({ show }) => {
  return (
    <div className={`${show ? "w-full " : "w-3/12 max-[700px]:hidden"} p-2`}>
      <h3 className="text-lg font-semibold">Things to keep in mind</h3>

      <div className="my-3 p-2 rounded-md border-2 border-[#2da3dc] bg-[#f4fbff]">
        <h4 className="font-semibold mb-2">Exclusion criteria</h4>
        <p className="text-sm">
          Children who have visual/hearing/ physical impairments, neuro-motor
          disabilities, epilepsy /fits/seizures, and/or mental disorders should
          be excluded from this study.
        </p>
      </div>
      <div className="my-3 p-2 rounded-md border-2 border-[#2da3dc] bg-[#f4fbff]">
        <h4 className="font-semibold mb-2">Inclusion criteria</h4>
        <p className="text-sm">
          Children who fail one or more subjects or are underperforming or seem
          uninterested in academics, and/or are inattentive, should be included.
        </p>
      </div>
    </div>
  );
};

export default Instruction;
